import {SequenceMapPreviewJustify} from './BulkEditModsConstants';

export type ModPatternParams = {
  templateVersionId: number;
  targetVersionIds: Array<number>;
  applyBaseMods: boolean;
  overwriteExistingMods: boolean;
  justify: SequenceMapPreviewJustify;
  startPos?: number | null;
} & ({shouldClone: false; folderId: null} | {shouldClone: true; folderId: string});

export const MAX_NUM_TARGET_CHIPS = 2;

export const DEFAULT_PATTERN_HIGHLIGHT_FILL = 'rgba(235, 135, 21, 0.2)';
